import { defineStore } from "pinia";

export const useSidebarStore = defineStore({
  id: "sidebar",
  state: () => ({
    open: false,
    id: 0,
    data: {},
    isSidebarOpen: false,
    selected: "",
  }),
  getters: {
    getData(state) {
      return state.data;
    },
  },
});
